import { View } from 'react-native';
import { Text } from '@/components/ui/text';
import { Icon } from '~/global/components/icon/Icon';
import { useTranslation } from 'react-i18next';

export const MealLogEmpty = () => {
  const { t } = useTranslation('meal');

  return (
    <View className="flex-1 flex items-center justify-center gap-4 py-10">
      <Icon
        name="UtensilsCrossed"
        size={48}
        className="text-text-muted opacity-50"
      />
      <Text className="text-lg font-sora-semibold text-text-muted text-center">
        {t('empty.title')}
      </Text>
      <Text className="text-sm text-text-muted text-center max-w-[240px]">
        {t('empty.description')}
      </Text>
    </View>
  );
};
